var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 48L44 56L62 38M71.6047 19.994C72.4284 21.9861 74.0094 23.5696 76.0002 24.3963L82.9809 27.2879C84.9731 28.1131 86.5559 29.696 87.3811 31.6882C88.2063 33.6805 88.2063 35.919 87.3811 37.9112L84.4917 44.8872C83.6661 46.8803 83.665 49.1211 84.4943 51.1133L87.3787 58.0872C87.7878 59.0739 87.9984 60.1316 87.9986 61.1998C87.9988 62.268 87.7885 63.3257 87.3797 64.3126C86.9709 65.2995 86.3717 66.1961 85.6163 66.9513C84.8609 67.7065 83.9641 68.3054 82.9771 68.7139L76.0014 71.6035C74.0094 72.4272 72.426 74.0082 71.5993 75.9991L68.7078 82.9801C67.8826 84.9723 66.2998 86.5552 64.3076 87.3804C62.3154 88.2056 60.077 88.2056 58.0849 87.3804L51.1091 84.4909C49.1169 83.6677 46.8793 83.6694 44.8883 84.4955L37.9076 87.383C35.9165 88.2063 33.68 88.2056 31.6895 87.3811C29.6989 86.5565 28.117 84.9756 27.2913 82.9854L24.3989 76.0024C23.5752 74.0103 21.9942 72.4268 20.0034 71.6001L13.0227 68.7085C11.0313 67.8836 9.44902 66.3018 8.62353 64.3107C7.79803 62.3195 7.79691 60.0821 8.62042 58.0902L11.5099 51.1142C12.333 49.1219 12.3313 46.8842 11.5052 44.8931L8.61989 37.9071C8.21081 36.9204 8.00017 35.8627 8 34.7945C7.99983 33.7263 8.21013 32.6686 8.61889 31.6817C9.02765 30.6949 9.62686 29.7982 10.3823 29.043C11.1377 28.2878 12.0345 27.6889 13.0215 27.2804L19.9972 24.3909C21.9875 23.5679 23.5699 21.9888 24.3972 20.0002L27.2887 13.0192C28.1139 11.027 29.6967 9.44414 31.6889 8.61892C33.6811 7.79369 35.9195 7.79369 37.9117 8.61892L44.8874 11.5085C46.8796 12.3317 49.1172 12.33 51.1082 11.5038L58.0919 8.6234C60.0838 7.79864 62.3217 7.79881 64.3135 8.62387C66.3053 9.44892 67.8879 11.0313 68.7132 13.0231L71.6056 20.0061L71.6047 19.994Z",
    stroke: "url(#paint0_linear_1168_8915)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1168_8915",
    x1: 48,
    y1: 8,
    x2: 48,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91CCED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F889F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckVerified);
export default __webpack_public_path__ + "static/media/check_verified.865a0dd9f36b41f2cbdfad29405f165e.svg";
export { ForwardRef as ReactComponent };